import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SplashComponent } from './components/splash/splash.component';
import { NgIf } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations'; 



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SplashComponent, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1500ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('1500ms ease-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class AppComponent {
  title = 'webapp';
  showSplash = true;
}
